export default {
  name: 'change-management',
  translationKey: 'change-management-module',
  routePrefix: 'change-management',
  routeNamePrefix: 'admin.change-management',
  directRoutesAvailable: false,
}
